import { lazyWithPreload } from '@kk/shared/utils/async';

const Organization = lazyWithPreload(async () => await import('./index'));

export default {
  id: 'organization',
  path: '/organization',
  element: <Organization />,
} as const;
